<template>
  <a-modal
      title="识别录入"
      :visible="visible"
      :width="600"
      @ok="handleOk"
      @cancel="handleCancel"
  >
    <a-form-model ref="targetForm" :model="form" :rules="rules" :label-col="{span: 5}" :wrapper-col="{span: 18}">
      <a-row class="form-row">
        <a-col :lg="24" :md="24" :sm="24">
          <a-form-model-item label="签证信息" prop="content">
            <a-textarea v-model="form.content" placeholder="内容" :rows="12"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>


import {HttpMixins} from "@/mixins/http-mixins";

export default {
  name: "BindModal",
  mixins: [HttpMixins],
  data() {
    return {
      visible: false,
      form: {},
      accountList: [],
      lastFetchId: 0,

      labelCol: {
        xs: {span: 24},
        sm: {span: 5},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
      },
      rules: {
        content: [
          {required: true, message: '请输入内容!'},
        ],
      },

      url: {
        bind: window._CONFIG['domainURL'] + "/usExpeditor/bind",
        bindSearch: window._CONFIG['domainURL'] + "/usApplicant/bindSearch",
      }
    }
  },
  methods: {
    show() {
      this.form = {};
      this.visible = true;
    },
    handleOk() {
      let that = this
      this.$refs.targetForm.validate(valid => {
        if (valid) {
          let data = {}
          let content = that.form.content.split('\n')
          if (content.length < 11) {
            that.$message.error('信息不完整');
            return
          }
          data.name = content[0].replace('中文姓名', '').replace('：', '').replace(':', '').trim()
          //data.type = content[1].replace('签证类型', '').replace('：', '').replace(':', '').trim()
          //data.area = content[2].replace('签证领区', '').replace('：', '').replace(':', '').trim()
          data.uid = content[3].replace('签证UID', '').replace('：', '').replace(':', '').trim()
          let birth = content[4].replace('出生日期（须与uid里信息一致）', '').replace('：', '').replace(':', '').trim()
          const regex = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/
          if (regex.test(birth)) {
            data.birthday = birth
          }
          data.email = content[5].replace('电子邮箱（须与uid里信息一致）', '').replace('：', '').replace(':', '').trim()

          data.receipt = content[7].replace('收据编号', '').replace('：', '').replace(':', '').trim()

          data.aa = content[9].replace('AA码', '').replace('：', '').replace(':', '').trim()
          data.bingCount = content[10].replace('已绑定协调员次数（不如实告知后果自负）', '').replace('：', '').replace(':', '').trim()
          that.$emit('complete', data);
          that.visible = false;
        }
      })
    },
    handleCancel() {
      this.visible = false;
    }
  }
}
</script>

<style scoped>

</style>
